import { Component, Input, OnInit } from "@angular/core";
import { CardView } from "src/app/interfaces/cardview";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";
import { CriacaoProdutoFormComponent } from "./criacao-produto/criacao-produto-form/criacao-produto-form.component";


@Component({
    selector: 'app-amazon',
    templateUrl: './amazon.component.html',
    styleUrls: ['./amazon.component.css'],
    standalone: false
})
export class AmazonComponent implements OnInit {
  

  criacaoProduto = CriacaoProdutoFormComponent;
  @Input() parentRow:CardView;
  condition:string;
  ngOnInit(): void {
      if ( ObjectUtil.isNotEmpty(this.parentRow)){
        this.condition = `codecontract=${this.parentRow.linha['CODECONTRACT']} and codeproduct=${this.parentRow.linha['CODEPRODUCT']}`
      }
      
  }

}
